import { TrainingWorkoutFormattedProps, TrainingWorkoutTypeEnum } from '../index'

export const reorder = (items: TrainingWorkoutFormattedProps[], startIndex: number, endIndex: number) => {
  return {
    trainingWorkoutId: (items[startIndex].type === 'NORMAL') ? items[startIndex].id : null,
    groupTrainingWorkoutId: (items[startIndex].type === 'GROUP') ? items[startIndex].id : null,
    newSort: endIndex + 1
  }
}

export const getInitialURL = (id: string, type: TrainingWorkoutTypeEnum | null) => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    return `professional-athlete-trainings/${id}/professional-athlete-training-workouts`
  }
  return `trainings/${id}/training-workouts`
}

export const getRemoveURL = (trainingWorkoutId: string, type: TrainingWorkoutTypeEnum | null) => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    return `professional-athlete-training-workouts/${trainingWorkoutId}`
  }
  return `training-workouts/${trainingWorkoutId}`
}

export const getUngroupURL = (trainingWorkoutId: string, type: TrainingWorkoutTypeEnum | null) => {
  if (type === TrainingWorkoutTypeEnum.ATHLETE) {
    return `professional-athlete-training-workouts/${trainingWorkoutId}/ungroup`
  }
  return `training-workouts/${trainingWorkoutId}/ungroup`
}

export const ucfirst = (name: string) => {
  const nameFormatted = `${name.replace('_', ' ')[0].toUpperCase()}${name.replace('_', ' ').substring(1).toLowerCase()}`
  return nameFormatted
}
